export default {
    grouped: null,
    searched: null,
    trainer: null,
    trainer_course_monthly_stats: null,
    created: null,
    patched: null,
    deleted: null,
};



// WEBPACK FOOTER //
// ./src/store/trainer/state.js